import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as IconRemoveImage } from 'assets/svg/icon-remove-image.svg'

interface TicketImageUploadProps {
  images: File[]
  onAddImages: (event: React.ChangeEvent<HTMLInputElement>) => void
  onRemoveImage: (index: number) => void
  placeholder?: string
  className?: string
}

const base = 'ticketImageUpload'

const TicketImageUpload: React.FC<TicketImageUploadProps> = ({
  images,
  onAddImages,
  onRemoveImage,
  placeholder,
  className = '',
}) => {
  const { t } = useTranslation('ticket')

  const fileInputRef = useRef<HTMLInputElement | null>(null)

  const triggerFileInput = () => {
    fileInputRef.current?.click()
  }
  return (
    <div className={`${base} ${base}__container ${className}`}>
      {images?.length < 5 && (
        <div className={`${base}__image-upload-container`}>
          <button
            className={`${base}__image-upload-button`}
            onClick={triggerFileInput}
            type='button'
          >
            {t('images.upload')}
          </button>
          <input
            type='file'
            multiple
            accept='image/jpeg, image/jpg, image/png'
            onChange={onAddImages}
            placeholder={placeholder || t('images.upload')}
            data-testid='TicketImageUpload-Input'
            ref={fileInputRef}
            hidden
          />
        </div>
      )}
      <div className={`${base}__preview-list`}>
        {images?.map((image: File, index: number) => (
          <div key={index} className={`${base}__image-item`}>
            <img
              src={URL.createObjectURL(image)}
              alt={`preview-${index}`}
              className={`${base}__image-preview`}
              style={{ maxWidth: 100, maxHeight: 100, objectFit: 'cover' }}
            />
            <button
              type='button'
              className={`${base}__remove-btn`}
              onClick={() => onRemoveImage(index)}
              data-testid={`TicketImageUpload-RemoveBtn-${index}`}
            >
              <IconRemoveImage />
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TicketImageUpload
